module.exports = require("./../../_gen/starling/assets/AtfTextureFactory");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/assets/AtfTextureFactory.js
// module id = 151
// module chunks = 0